import React from 'react';
import PropTypes from 'prop-types';
import { RadioGroup } from '@pattern-library/radio';

const propTypes = {
    otpErrorMessage: PropTypes.string,
    checkedPhone: PropTypes.string.isRequired,
    phoneNumbers: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string.isRequired,
            value: PropTypes.string.isRequired
        }).isRequired
    ).isRequired
};
const defaultProps = {};

function VerifyPhone(props) {
    const { otpErrorMessage, checkedPhone, phoneNumbers } = props;
    const options = phoneNumbers.map(phone => ({
        id: phone.name,
        value: phone.name,
        label: <span dangerouslySetInnerHTML={{ __html: phone.value }} />
    }));

    return (
        <div id="phoneField" className="text--center verification-method-phone-field">
            {otpErrorMessage && (
                <div className="is-warning">
                    <p className="asc-form-help">{otpErrorMessage}</p>
                </div>
            )}
            <RadioGroup
                id="verification-method-phone-numbers"
                className="text--center"
                legend="Select Phone Number"
                hideLegend
                orientation="vertical"
                hasBorder
                isRequired
                showRequiredAsterisk={false}
                name="SelectedPhoneNumber"
                initialValue={checkedPhone}
                options={options}
            />
        </div>
    );
}

VerifyPhone.propTypes = propTypes;
VerifyPhone.defaultProps = defaultProps;
export default VerifyPhone;
